import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import titleImg from '../../../asset/img/edocument_title_img.svg';

import Typography from '../../../components/common/Typography';
import SubTitleSection from '../../../components/SubTitleSection';
import Chips from '../../../components/common/Chips';
import { eDocumentsListButton } from '../../../common/data';
import NationalTaxData from './NationalTaxData';
import Button from '../../../components/common/Button';

// import SubTitleSection from '../../../components/SubTitleSection';
// import Typography from '../../../components/common/Typography';
// import Button from '../../../components/common/Button';

const Step4 = ({ stepHandler }) => {
  const { t } = useTranslation('eDocuments');
  const { t: tCommon } = useTranslation('common');

  const listButton = eDocumentsListButton(tCommon);

  const [selected, setSelected] = useState('1');

  const handleClick = value => {
    console.log('value >>', value);
    setSelected(value);
  };

  return (
    <div>
      <SubTitleSection title={t('linkToData.step4.title')} img={titleImg} />
      <div className="step4InfoContainer">
        {/* 목록 칩 버튼 */}
        <div className="listButtonContainer">
          <div className="listButton displayFlex">
            {listButton.map(item => (
              <Chips
                key={item.value}
                size="large"
                variant={'eDocuments'}
                color={selected === item.value ? 'secondary' : 'default'}
                onClick={() => handleClick(item.value)}>
                {item.label}
              </Chips>
            ))}
          </div>
        </div>
        <div className="backgroundBox" style={{ bottom: 0, top: 'auto' }}></div>
      </div>

      {/* 국세청자료 */}
      <NationalTaxData
        selected={selected}
        monthlyData={[{ total: { amount: 1000000, insurance: 100000 } }]}
      />

      {/* 확인했어요 */}
      <div className="stepButtonContainer">
        <Button
          fullWidth
          color="primary"
          value={t('linkToData.step4.button')}
          onClick={() => stepHandler(7)}
        />
      </div>
    </div>
  );
};

export default Step4;
